import { ARTICLES, type Article } from './articles/data'
import type { I18nDescriptor } from './metals/types'
import { type GalleryVideo, VIDEOS } from './videos'

/** A gallery row. `key` and `title` sit outside the union so the list's shared
 *  shell renders both kinds without narrowing. */
export type ContentEntry = { key: string; title: I18nDescriptor } & (
  | { kind: 'video'; video: GalleryVideo }
  | { kind: 'article'; article: Article }
)

/** Films (intro → impacts → metals), then the stories by editorial `order`.
 *  Collected from `VIDEOS` and `ARTICLES`, so nothing is authored here. */
export const CONTENT: ContentEntry[] = [
  ...VIDEOS.map((video) => ({
    kind: 'video' as const,
    key: `video-${video.id}`,
    title: video.title,
    video,
  })),
  // Copied first: `ARTICLES` is exported and `sort` is in place.
  ...[...ARTICLES]
    .sort((a, b) => a.order - b.order)
    .map((article) => ({
      kind: 'article' as const,
      key: `article-${article.id}`,
      title: article.title,
      article,
    })),
]
